<template>
  <div class="text">
    <h3 class="fw-bold mb-5">General terms and conditions M.E.D.U.Z.Z.A</h3>
    <p>
      You can shop without any risks - below you will find important information
      about shopping at M.E.D.U.Z.Z.A. Please read our terms and conditions
      carefully as they regularize the contractual relationship between you and
      M.E.D.U.Z.Z.A.
    </p>
    <p class="fw-bold mt-5">§1. Contractual partner</p>
    <ul>
      <li>M.E.D.U.Z.Z.A.</li>
      <li>Mönchhofallee 1</li>
      <li>D-65451 Lauterbach Germany</li>
    </ul>
    <p class="fw-bold mt-5">
      §2. Scope of application of general terms and conditions
    </p>
    <p>
      The following general terms and conditions shall apply to all contracts
      concluded via our online shop www.dress-for-less.de or www.meduzza.com.
      Any regulations deviating from these conditions shall not be applicable
      unless we have given our written confirmation.
    </p>
    <p>
      Only the version of terms and conditions provided on our website at the
      time of your order shall prevail.
    </p>
    <p class="fw-bold mt-5">§3. Conclusion of contract</p>
    <p>
      The display of products on the shop page does not represent a legally
      binding offer on our part. By clicking the "Buy" button, you make a
      binding purchase offer for the items in your shopping cart and thereby
      agree to our terms and conditions. The order confirmation, which we will
      automatically send to you as soon as we receive your order, only confirms
      the contents and the receipt of your order. The contract is not concluded
      until we send you the ordered items and the shipping is confirmed via a
      shipping confirmation e-mail. Despite this, when using prepayment as
      payment method, the purchase contract is concluded once we have sent you
      an order confirmation via e-mail.
    </p>
    <p>
      You are bound by your purchase order for 5 working days - irrespective of
      your right of cancellation that you obtain as a consumer when placing an
      order.
    </p>
    <p>
      Your offer shall be refused if you do not receive a shipping confirmation
      from us within 5 working days after you have placed your order, or if we
      refuse your order via e-mail.
    </p>
    <p>
      If you make a prepayment, the ordered items will be shipped only after
      receipt of your payment to our bank account. Payment is due immediately,
      or within 7 calendar days after receipt of the order confirmation at the
      latest. If we have not received your payment within 7 calendar days after
      receipt of the order confirmation, we will withdraw from the contract
      prematurely with the consequence that your order is invalid and we have no
      obligation to supply. Therefore, if you make a prepayment, items can be
      reserved for a maximum of 7 calendar days.
    </p>
    <p>
      If an item is not available, we are obliged to inform you about the
      unavailability and to reimburse any advance payments.
    </p>
    <p>
      We do not accept orders with a value of goods under 39,90€ after deduction
      of all discount codes and price reductions.
    </p>
    <p>
      We will save your purchase order but you cannot access it on our website
      after you complete your ordering process. However, you can print out the
      ordering data after placing an order.
    </p>
    <p>
      VContracts concerning items that are offered on www.meduzza.de or
      www.meduzza.com can be concluded in German and English.
    </p>
    <p class="fw-bold mt-5">§4 Prices</p>
    <p>
      The prices at the time of order shall apply. The prices listed on the shop
      page are inclusive of VAT. Shipping costs and, if applicable, cash on
      delivery charges, River service fee for invoice purchases or express
      delivery charges are charged additionally.
    </p>
    <p>
      The shipping costs incurred are clearly stated in the ordering process.
    </p>
    <p class="fw-bold mt-5">Consequences of cancellation</p>
    <p>
      If you withdraw from this contract, we shall refund all payments that we
      have received from you, including delivery costs (with the exception of
      additional costs that arise if you have selected a form of delivery other
      than the cheapest form of standard delivery offered by us) without undue
      delay and within fourteen days at the latest from the date on which we
      received the notice of cancellation. For this refund we use the same
      method of payment that you used for the original transaction, unless
      expressly agreed otherwise with you; in no event will you be charged any
      fees for this refund. We may refuse the refund until the goods have been
      returned to us or until you have provided evidence that you have returned
      the goods, whichever is earlier.
    </p>
    <p>
      You must return or hand over the goods to M.E.D.U.Z.Z.A GmbH (Returns
      department, Mönchhofallee 1, 65451 Lauterbach, Germany) without undue
      delay and, at all events, within fourteen days at the latest from the date
      on which you notified us of your withdrawal from the contract. The
      deadline shall be deemed to have been complied with if the goods are
      dispatched prior to expiry of the deadline. The costs of returning the
      goods shall be borne by us.
    </p>
    <p>
      You shall only be required to compensate any loss of value if said loss of
      value can be attributed to any unnecessary handling of the goods for the
      purpose of testing the condition, properties and functionality of said
      goods.
    </p>
  </div>
</template>

<script>
export default {
  name: "TermsConditions",
};
</script>

<style scoped>
.text {
  margin: 100px 150px 60px 25px;
  text-align: start;
}
@media (max-width: 576px) {
  .text {
    font-size: 12px;
    width: 80%;
    margin-top: 120px;
  }
}
</style>
